import axios from 'axios'
import isUndefined from 'lodash/isUndefined'
import omitBy from 'lodash/omitBy'

export const authenticateAccount = ({ mfa }) => {
  return axios.put(`/users/v1/member/verify`, omitBy({ mfa }, isUndefined))
}
